import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import styled from "styled-components";
import {
  getOneDivisionItem,
  getOneGovernanceDocumentItem,
  getOnePolicyItem,
} from "../../api/api";
import { IInnerDivision } from "../../types/inner_page";
import { Comment, TailSpin } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../Layout/InnerPageLayout";
import { Link, useParams } from "react-router-dom";
import Caac from "../Chart/caac.js";
import {
  Card,
  Col,
  Row,
  Tab,
  Tabs,
  Modal,
  Container,
  Button,
} from "react-bootstrap";
import axios from "axios";
import { json } from "stream/consumers";

const GovernanceDocuments = () => {
  let { id } = useParams();

  const { i18n, t } = useTranslation();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  type File = {
    id: string | number;
    title: string;
    fileName: string;
    fileUrl: string;
  };

  const [files, setFiles] = useState<File[]>([]);
  const { isLoading, error, data, refetch }: any = useQuery(
    `innerDivisionData-${id}`,
    () =>
      getOneGovernanceDocumentItem({ id: id || "1", language: i18n.language })
  );

  // useEffect(() => {
  // console.log("datax", data?.data?.attributes);
  // let res = data?.data?.attributes;
  // setTitle(res.title);
  // setContent(res.content);
  // let doc_files = res.governance_documents_files ? [];
  // //setFiles(data?.data?.attributes.governance_documents_files);
  // const hrFilesList = doc_files.map((item: any) => ({
  //     id: item.id,
  //     title: item.attributes.Title,
  //     fileName: item.attributes.file.data.attributes.name,
  //     fileUrl:
  //       process.env.REACT_APP_CMS +
  //       item.attributes.file.data.attributes.url,
  //   }));

  //   setFiles(hrFilesList);
  // }, [data]);

  useEffect(() => {
    if (!data || !data.data?.attributes) return;

    // Extract attributes safely with defaults
    const {
      title = "",
      content = "",
      governance_documents_files,
    } = data.data.attributes;

    // Set title and content
    setTitle(title);
    setContent(content);

    // Ensure governance_documents_files is an array

    // Map governance documents
    // const hrFilesList = governance_documents_files.map((item: any) => {
    //   const fileData = item.attributes?.file?.data?.attributes;

    //   return {
    //     id: item.id,
    //     title: item.attributes?.Title || "Untitled",
    //     fileName: fileData?.name || "Unknown",
    //     fileUrl: fileData?.url
    //       ? `${process.env.REACT_APP_CMS}${fileData.url}`
    //       : "#",
    //   };
    // });
    // Loop through the data and extract necessary information
    setFiles(
      governance_documents_files.data.map((item: any) => {
        const fileAttributes = item.attributes?.file?.data?.attributes;

        return {
          id: item.id,
          title: item.attributes?.title,
          fileName: fileAttributes?.name,
          fileUrl: `${process.env.REACT_APP_CMS}${fileAttributes?.url}`,
        };
      })
    );

    // setFiles(governance_documents_files);
  }, [data]);

  //   let pageItem: IInnerDivision = data["data"];

  if (isLoading)
    return (
      <InnerPageLayout>
        <LoaderContainer>
          <TailSpin color="#ffffff" height={70} width={70} />
        </LoaderContainer>
      </InnerPageLayout>
    );

  if (error)
    return (
      <InnerPageLayout>
        <div></div>
      </InnerPageLayout>
    );

  return (
    <InnerPageLayout>
      <>
        <Row>
          <Col md={12}>
            <Card
              id={i18n.language === "en" ? "custom-card-en" : "custom-card-ar"}
              className="custom-card right mb-4"
            >
              <Card.Header className="custom-card-header">{title}</Card.Header>
              <Card.Body className="d-flex p-0">
                <div className="text-section p-4">
                  <ReactMarkdown className="description">
                    {content}
                  </ReactMarkdown>

                  {/* {files?.length === 0 && <center>{t("no_files")}</center>} */}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {files?.length > 0 && (
          <Row>
            <Col md={12}>
              <Card className="mb-4">
                <Card.Header>
                  {t("docs")}
                </Card.Header>
                <Card.Body>
                  {files?.map((file: File, index: number) => (
                    <Row
                      key={index}
                      className="align-items-center file-item mb-3 py-2"
                    >
                      <Col xs={8} className="file-name">
                        <i
                          className="bi bi-file-earmark-text"
                          style={{ marginRight: "20px", color: "#007bff" }}
                        ></i>{" "}
                        {file.title}
                      </Col>
                      <Col xs={4} className="text-end">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          href={file.fileUrl}
                        >
                          {t("donwload_file")}
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </>
    </InnerPageLayout>
  );
};

const LoaderContainer = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default GovernanceDocuments;
